import useCustomNavigate from "../../../common/hooks/useCustomNavigate";
import ModalTemplate from "../../../common/modal/modalTemplate";
import { getBookAgainDetails } from "../../../storage";
import { theme } from "../../../theme";

import "./BookAgain.css"

const BookAgain = ({show, handelClose}) => {
    // const bookAgainDetails = getBookAgainDetails();
    const { navigateToCustom } = useCustomNavigate();

    const closeView = () => handelClose();
    const bookAgain = () => {
        handelClose();

        const bookAgainDetails = getBookAgainDetails();
        navigateToCustom(`/home?bookAgain=${bookAgainDetails.job_id}`);
    }

    return(
        <ModalTemplate
            show={show}
            centered
            closeFun={null}
            isRemoveBodyPadding={true}
            size={'sm'}
            body={
                <div className="job-cancelled-card">
                    <button className="job-cancelled-close-btn" onClick={closeView}>
                        <i className="fas fa-times"></i>
                    </button>

                    <h4 className="job-cancelled-title">
                        Job cancelled
                    </h4>

                    <p className="job-cancelled-description">
                        Your job has been cancelled and a full refund has been issued.
                    </p>

                    <button type="button" className={`btn bg-gradient-${theme.main} mt-4 w-100 btn-sm`} onClick={bookAgain}>Book again</button>
                </div>
            }
        />
    );
};

export default BookAgain;